<script setup lang="ts">
import { useScopeStore } from "@/stores/scope";
import { ScopeType } from "@soft-db/monitoring-api-client";

defineProps<{
	scope: ScopeType;
}>();

const { isScope } = useScopeStore();
</script>

<template>
	<slot v-if="isScope(scope)" />
	<slot v-else name="fallback" />
</template>
